import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDialog, MatDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { AddEditDivisionComponent } from '../add-edit-division/add-edit-division.component';
import { SchoolYearService } from '../../../../../services/schoool-year/school-year.service';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { SchoolYear } from '../../../../../models/school-years/school-year';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { CurriculumService } from '../../../../../services/curricula/curriculum.service';
import { environment } from '../../../../../../../environments/environment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../const/date-format';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-add-edit-school-year',
    templateUrl: './add-edit-school-year.component.html',
    styleUrls: ['./add-edit-school-year.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class AddEditSchoolYearComponent implements OnInit, OnDestroy, AfterViewInit {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    public shifts: any[];
    public courseYears: any[];
    public curricula: any[];
    public contador = 0;
    confirmDialogRef: any;
    private sub: any;
    public schoolYear: SchoolYear = new SchoolYear();

    schoolYearId = -1;

    minDate = new Date(1930, 0, 1);

    courseYearFormGroup;
    anioFormControl;
    startDateFormControl;
    finishDateFormControl;
    public data: any;

    mask = [ /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerFinishDate;
    maskedInputControllerStartDate;

    @ViewChild('startDate', { read: ViewContainerRef }) public startDate;
    @ViewChild('finishDate', { read: ViewContainerRef }) public finishDate;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private location: Location,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private schoolYearService: SchoolYearService,
                private route: ActivatedRoute,
                private courseYearService: CourseYearService,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private sweetAlertService: SweetAlertService,
                private translateService: TranslateService,
                private curriculumService: CurriculumService) {
        this.initializeFormControlValidators();
    }

    initializeFormControlValidators() {
        this.courseYearFormGroup = this.fb.group({
            anioFormControl: ['', [Validators.required]],
            startDateFormControl: ['', [Validators.required]],
            finishDateFormControl: ['', [Validators.required]],
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    ngOnInit(): void {
        this.blockUIList.start('Cargando datos...');
        this.data = this.route.snapshot.data;
        this.sub = this.route.params.subscribe(params => {
            this.schoolYearId = params['id'] !== undefined ? +params['id'] : -1;
        });
        this.contador = 0;
        this.loadData();
        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.courseYearFormGroup.get('anioFormControl').disable();
        this.courseYearFormGroup.get('startDateFormControl').disable();
        this.courseYearFormGroup.get('finishDateFormControl').disable();
    }

    public loadData() {
        this.shifts = [];
        this.courseYears = [];
        this.schoolYear = new SchoolYear();
        Observable.combineLatest(
            this.shiftService.getAll(),
            this.courseYearService.getAll(),
            this.schoolYearService.getById(this.schoolYearId),
            this.curriculumService.getAll()
        ).subscribe(([shifts, courseYears, schoolYear, curricula]) => {
            this.shifts = shifts;
            this.courseYears = courseYears;
            this.curricula = curricula;
            console.log('curricula', this.curricula);
            this.courseYears.forEach(e => e.Divisions = []);
            if (schoolYear) {
                this.schoolYear = schoolYear;
            }
            const observables = [];
            this.shifts.forEach(e => {
                observables.push(this.divisionService.getAllWithShiftId(e.Id, this.schoolYearId));
            });
            Observable.combineLatest(
                observables
            ).subscribe((divisionsByShift) => {
                if (this.schoolYearId === -1) {
                    divisionsByShift.forEach(dbs => {
                        dbs.divisions.forEach(e => {
                            console.log('division', e);
                            e.ClonedDivisionId = e.Id;
                            e.Id = -1;
                        });
                    });
                }
                this.groupDivision(divisionsByShift);
                this.blockUIList.stop();
            });
        });

    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();

        this.maskedInputControllerFinishDate.destroy();
        this.maskedInputControllerStartDate.destroy();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.maskedInputControllerFinishDate = textMask.maskInput({
                inputElement: this.finishDate.element.nativeElement,
                mask: this.mask
            });

            this.maskedInputControllerStartDate = textMask.maskInput({
                inputElement: this.startDate.element.nativeElement,
                mask: this.mask
            });
        });
    }

    public groupDivision(divisionsByShift) {
        divisionsByShift.forEach(dbs => {
            const shift = this.shifts.find(s => dbs.shiftId === s.Id);
            shift.divisionsByCourseYear = this.courseYears.map(e => {
                return {
                    CourseYearName: e.CourseYearName,
                    Divisions: [],
                    Id: e.Id
                };
            });
            dbs.divisions.forEach(d => {
                let course = shift.divisionsByCourseYear.find(dbc => dbc.Id === d.CourseYearId);
                if (course === undefined) {
                    course = {
                        Id: d.CourseYearId,
                        CourseYearName: d.CourseYearName,
                        Divisions: [],
                    };
                    shift.divisionsByCourseYear.push(course);
                }
                d.IsActive = true;
                course.Divisions.push(d);
            });
        });
    }


    public editDivision(division) {
        const config: MatDialogConfig = {
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                division: {
                    Id: division.Id,
                    DivisionName: division.DivisionName,
                    CurriculumId: division.CurriculumId
                },
                curricula: this.curricula
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditDivisionComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result !== true) {
                division.DivisionName = result.division.DivisionName;
                division.CurriculumId = result.division.CurriculumId;
            }
        });
    }

    public deleteDivision(division) {
        this.sweetAlertService.question(
            '',
            '¿Desea borrar la comisión?',
            'Aceptar',
            'Cancelar',
            () => {
                division.IsActive = false;
            },
            () => {
            });
    }

    addDivision(dg) {
        const config: MatDialogConfig = {
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                division: {
                    Id: -1,
                    DivisionName: '',
                    CurriculumId: 0
                },
                curricula: this.curricula
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditDivisionComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result !== true) {
                dg.Divisions.push({
                    Id: result.division.Id,
                    DivisionName: result.division.DivisionName,
                    CurriculumId: result.division.CurriculumId,
                    CourseYearId: dg.Id,
                    IsActive: true
                });
            }
        });
    }

    back() {
        this.location.back();
    }

    save() {
        let b = false;
        this.shifts.forEach(s => {
            s.divisionsByCourseYear.forEach(c => {
                if (c.Divisions.filter(e => e.IsActive).length === 0) {
                    b = true;
                }
            });
        });
        if (b) {
            this.sweetAlertService.question(
                'Información',
                'Existen años en los que no se cargaron divisiones. ¿Es correcto?',
                'Aceptar',
                'Cancelar',
                () => {
                    this.saveData();
                },
                () => {

                });
        } else {
            this.saveData();
        }
    }

    saveData() {
        this.blockUIList.start('Guardando datos...');
        const data = {
            Id: this.schoolYear.Id,
            Description: this.schoolYear.Description,
            StartDate: this.schoolYear.StartDate,
            FinishDate: this.schoolYear.FinishDate,
            Shifts: this.prepareShifts()
        };

        this.schoolYearService.add(data).subscribe(response => {
            this.schoolYearId = response.Id;
            this.translateService.get('LABELS.DATA_SAVED_CORRECTLY').subscribe(res => {
                this.sweetAlertService.success('', res);
            });
            this.router.navigate(['pages/management/schoolyear']);
            this.blockUIList.stop();
        }, error => {
            this.blockUIList.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    private prepareShifts() {
        const shiftData = [];
        this.shifts.forEach(shift => {
            shiftData.push({
                Id: shift.Id,
                Divisions: this.prepareDivisions(shift.divisionsByCourseYear)
            });
        });

        return shiftData;
    }

    private prepareDivisions(divisionsByCourseYear: any) {
        const divisionsData = [];
        divisionsByCourseYear.forEach(e => {
            e.Divisions.forEach(d => {
                console.log('division>>>>>', d);
                if (!(d.Id === -1 && !d.IsActive)) {
                    divisionsData.push({
                        Id: d.Id,
                        ClonedDivisionId: this.schoolYearId === -1 ? d.ClonedDivisionId : d.Id,
                        DivisionName: d.DivisionName,
                        CourseYearId: d.CourseYearId,
                        IsActive: d.IsActive,
                        CurriculumId: d.CurriculumId
                    });
                }
            });
        });
        return divisionsData;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/add-edit-school-year/add-edit-school-year.component.ts